import { useEffect, type FC } from "react";
import { Field, Input, VStack } from "@chakra-ui/react";

import type { Form } from "./create-order-form-provider";
import { useCreateOrderForm } from "../lib/create-order-context";
import { CreateOrderFormLineCreator } from "./create-order-form-line-creator";

interface Props {
  initialValues?: Partial<Form>;
}

export const CreateOrderForm: FC<Props> = ({ initialValues }) => {
  const { values, errors, handleChange, setValues } = useCreateOrderForm();

  useEffect(() => {
    if (initialValues) {
      setValues({ ...values, ...initialValues });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  return (
    <VStack gap={2} w="full">
      <Field.Root>
        <Field.Label>
          Document Number
          <Field.RequiredIndicator />
        </Field.Label>
        <Input
          disabled={true}
          value={values.docNumber}
          onChange={handleChange("docNumber")}
        />
        <Field.ErrorText>{errors.docNumber}</Field.ErrorText>
      </Field.Root>

      <Field.Root>
        <Field.Label>PO Order Number</Field.Label>
        <Input
          value={values.POOrderNumber}
          onChange={handleChange("POOrderNumber")}
        />
      </Field.Root>

      <Field.Root>
        <Field.Label>Note</Field.Label>
        <Input value={values.note} onChange={handleChange("note")} />
        <Field.ErrorText>{errors.docNumber}</Field.ErrorText>
      </Field.Root>

      <CreateOrderFormLineCreator />
    </VStack>
  );
};
